import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {Locale} from "locale";
import {LocaleService} from "purchasing-shared/locale.service";
import {Observable} from "rxjs";
import {contextPath} from "site";
import {AvdbPricingResponse} from "./database-pricing/avdb-pricing-response";
import {OrgService} from "./shared/org.service";

const apiURL = `${contextPath}/api/`;
const avdbPricingURL = `${apiURL}avdb-pricing/`;

@Injectable()
export class DatabasePricingService {

	locale: Locale;

	constructor(
			private http: Http,
			localeService: LocaleService,
			private orgService: OrgService) {
		localeService.getLocale()
			.subscribe(locale => {
				this.locale = locale;
			});
	}

	getAvdbPricing(aircraftSeriesID: number, deviceModelIDs: Array<number>): Observable<AvdbPricingResponse> {
		let params = {
			aircraftSeriesID,
			deviceModelIDs,
		};
		return this.pricingRequest(params);
	}

	getAvdbPricingForDevices(deviceIDs: Array<number>, avdbProductKey?: string): Observable<AvdbPricingResponse> {
		let params = {
			deviceIDs,
			filterProductKeys: avdbProductKey,
		};
		return this.pricingRequest(params);
	}

	getAvdbPricingForAircraft(aircraftID: string, avdbProductKey?: string): Observable<AvdbPricingResponse> {
		let params = {
			aircraftID,
			filterProductKeys: avdbProductKey,
		};
		return this.pricingRequest(params);
	}

	getAvdbPricingForAircraftAndPortable(aircraftID: string, portableDeviceID?: number): Observable<AvdbPricingResponse> {
		let deviceIDs = portableDeviceID ? [portableDeviceID] : undefined;
		let params = {
			aircraftID,
			deviceIDs,
		};
		return this.pricingRequest(params);
	}

	private pricingRequest(params: Record<string, any>): Observable<AvdbPricingResponse> {
		return this.http.get(`${avdbPricingURL}${this.locale.wpcLocale}/`, {params, headers: this.orgService.contextHeader})
			.map(res => {
				let response = AvdbPricingResponse.fromJSON(res.json());
				response.params = params;
				return response;
			})
			.do(response => this.linkReponse(response));
	}

	private linkReponse(response: AvdbPricingResponse) {
		// TODO: Find a better way to handle this

		for (let device of response.devices) {
			for (let avdbType of device.avdbProductTypes) {
				for (let product of avdbType.products) {
					product.productType = avdbType;
				}
			}

			for (let bundle of device.bundles) {
				bundle.deviceID = device.id;
				bundle.deviceModelID = device.modelID;
			}
		}
	}
}
